<template>
  <h6 class="fg-header" @click="$emit('open', filter.filterId)">
    {{ filter.title }}
  </h6>
  <div class="fg-body form-group">
    <div
      class="form-check"
      v-for="option in filter.options"
      :key="option.value"
    >
      <input
        class="form-check-input"
        type="checkbox"
        :value="option.value"
        :name="'filter_' + option.value"
        :id="option.value"
        :checked="option.selected"
        @change="option.selected = !option.selected"
      />
      <label class="form-check-label" :for="option.value">
        {{ option.label }}
      </label>
    </div>
  </div>
  <!-- .fg-body -->
</template>
<script src="./ctrl-checkbox-filter.js"></script>
